<template>
  <div class="main">
    <div class="marquee-1 container-sm">
      <img class="ml-16" src="@/assets/types/acupuncture.png" width="50" />
      <img class="ml-16" src="@/assets/types/aircon_install.png" width="50" />
      <img class="ml-16" src="@/assets/types/appliance_repair.png" width="50" />
      <img class="ml-16" src="@/assets/types/architect.png" width="50" />
      <img class="ml-16" src="@/assets/types/baker.png" width="50" />
      <img class="ml-16" src="@/assets/types/barber.png" width="50" />
      <img class="ml-16" src="@/assets/types/bathroom_fitter.png" width="50" />
      <img class="ml-16" src="@/assets/types/bicycle_mechanic.png" width="50" />
      <img class="ml-16" src="@/assets/types/bike_mechanic.png" width="50" />
      <img class="ml-16" src="@/assets/types/blacksmith.png" width="50" />
      <img class="ml-16" src="@/assets/types/boiler_install.png" width="50" />
      <img class="ml-16" src="@/assets/types/bricklayer.png" width="50" />
      <img class="ml-16" src="@/assets/types/car_mechanic.png" width="50" />
      <img class="ml-16" src="@/assets/types/carpenter.png" width="50" />
      <img class="ml-16" src="@/assets/types/catering.png" width="50" />
      <img class="ml-16" src="@/assets/types/cleaner.png" width="50" />
      <img class="ml-16" src="@/assets/types/computersetup.png" width="50" />
      <img class="ml-16" src="@/assets/types/consultant.png" width="50" />
      <img class="ml-16" src="@/assets/types/cook.png" width="50" />
      <img class="ml-16" src="@/assets/types/dentist.png" width="50" />
      <img class="ml-16" src="@/assets/types/electrician.png" width="50" />
      <img class="ml-16" src="@/assets/types/floor_installation.png" width="50" />
      <img class="ml-16" src="@/assets/types/florist.png" width="50" />
      <img class="ml-16" src="@/assets/types/gardener.png" width="50" />
      <img class="ml-16" src="@/assets/types/generalbuilder.png" width="50" />
      <img class="ml-16" src="@/assets/types/graphic_designer.png" width="50" />
      <img class="ml-16" src="@/assets/types/hair_stylist.png" width="50" />
      <img class="ml-16" src="@/assets/types/handyman.png" width="50" />
      <img class="ml-16" src="@/assets/types/homeautoinstaller.png" width="50" />
      <img class="ml-16" src="@/assets/types/interior_designer.png" width="50" />
      <img class="ml-16" src="@/assets/types/iptv.png" width="50" />
      <img class="ml-16" src="@/assets/types/key_cutter.png" width="50" />
      <img class="ml-16" src="@/assets/types/lawyer.png" width="50" />
      <img class="ml-16" src="@/assets/types/leatherwork.png" width="50" />
    </div>
    <div class="marquee-2 container-sm mt-16">
      <img class="ml-16" src="@/assets/types/locksmith.png" width="50" />
      <img class="ml-16" src="@/assets/types/makeup_artist.png" width="50" />
      <img class="ml-16" src="@/assets/types/maninvan.png" width="50" />
      <img class="ml-16" src="@/assets/types/masseuse.png" width="50" />
      <img class="ml-16" src="@/assets/types/mechanic.png" width="50" />
      <img class="ml-16" src="@/assets/types/medium.png" width="50" />
      <img class="ml-16" src="@/assets/types/painter_artist.png" width="50" />
      <img class="ml-16" src="@/assets/types/painter_house.png" width="50" />
      <img class="ml-16" src="@/assets/types/performers.png" width="50" />
      <img class="ml-16" src="@/assets/types/personaltrainer.png" width="50" />
      <img class="ml-16" src="@/assets/types/phone_repair.png" width="50" />
      <img class="ml-16" src="@/assets/types/physio.png" width="50" />
      <img class="ml-16" src="@/assets/types/physiotherapist.png" width="50" />
      <img class="ml-16" src="@/assets/types/plumber.png" width="50" />
      <img class="ml-16" src="@/assets/types/programmer.png" width="50" />
      <img class="ml-16" src="@/assets/types/projectmanager.png" width="50" />
      <img class="ml-16" src="@/assets/types/psychologist.png" width="50" />
      <img class="ml-16" src="@/assets/types/satellite.png" width="50" />
      <img class="ml-16" src="@/assets/types/scaffolding.png" width="50" />
      <img class="ml-16" src="@/assets/types/shoesmith.png" width="50" />
      <img class="ml-16" src="@/assets/types/sports_therapist.png" width="50" />
      <img class="ml-16" src="@/assets/types/steel_worker.png" width="50" />
      <img class="ml-16" src="@/assets/types/stonemason.png" width="50" />
      <img class="ml-16" src="@/assets/types/tailor.png" width="50" />
      <img class="ml-16" src="@/assets/types/tattoo_artist.png" width="50" />
      <img class="ml-16" src="@/assets/types/teacher.png" width="50" />
      <img class="ml-16" src="@/assets/types/therapist.png" width="50" />
      <img class="ml-16" src="@/assets/types/tv_tuning.png" width="50" />
      <img class="ml-16" src="@/assets/types/tvinstall.png" width="50" />
      <img class="ml-16" src="@/assets/types/upholstery.png" width="50" />
      <img class="ml-16" src="@/assets/types/video_editor.png" width="50" />
      <img class="ml-16" src="@/assets/types/waiter.png" width="50" />
      <img class="ml-16" src="@/assets/types/website_design.png" width="50" />
      <img class="ml-16" src="@/assets/types/wedding_planner.png" width="50" />
      <img class="ml-16" src="@/assets/types/welder.png" width="50" />
    </div>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";

export default {
  mounted() {
    [...document.querySelectorAll('.marquee-1, .marquee-2')].map(row => {
      row.style.setProperty('--animation', 'slide');
      row.style.setProperty('width', '200%');
      row.innerHTML = row.innerHTML + row.innerHTML;
    });
  }
};
</script>

<style lang="scss" scoped>
.marquee-1,
.marquee-2,
.marquee-3,
.marquee-4,
.marquee-5 {
  display: flex;
  visibility: hidden;
  justify-content: center;
  height: 50px;

  @media (max-width: 1240px) {
    visibility: visible;
  }
}

.main {
  overflow: hidden;
  height: 125px;

  img {
    max-width: 200%;
    vertical-align: middle;
    box-sizing: border-box;
    transition: all 0.2s;
    height: 50px;

    &:hover {
      opacity: 0.5;
    }
  }

  .marquee-1, .marquee-2 {
    animation: slide 10s infinite alternate ease-in-out;

    &:nth-last-of-type(odd) {
      align-self: flex-end;
      --direction: 50%;
    }
  }
}

@keyframes slide {
  to {
    -webkit-transform: translateX(var(--direction, -50%));
    transform: translateX(var(--direction, -50%));
  }
}
</style>